import React from 'react';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import { Image } from '../../../../../components/Image';
import * as types from '../../../../../types';
import styles from './SubItems.module.scss';

interface SubItemDetails {
  name: string;
  imageUrl: string;
}

function subItemDetails(variant: types.IVariant, t: TFunction): SubItemDetails[] {
  return [
    {
      name: t('fi_series_2'),
      imageUrl: '/series2_images/f2-m.jpg',
    },
    {
      name: t('fi_series_2_base'),
      imageUrl: '/series2_images/f2-bua.jpg',
    },
    {
      name: t('fi_band'),
      imageUrl: `/product_images/additional-band/${variant.options.color}.jpg`,
    },
  ];
}

interface SubItemsProps {
  variant: types.IVariant;
}

export default function SubItems({ variant }: SubItemsProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('whats_included')}</div>
      <div className={styles.subItems}>
        {subItemDetails(variant, t).map((subItem) => (
          <div className={styles.subItem}>
            <div className={styles.subItemImageContainer}>
              <Image image={{ type: 'image', url: subItem.imageUrl }} alt={subItem.name} />
            </div>
            <div className={styles.subItemName}>{subItem.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
